export default class ContentModel {
    constructor(
        public openingsHoursLabel: string,
        public contactUsLabel: string,
        public sendEmailLabel: string,
        public travelDirectionsLabel: string
    ){}
}